<article class="itemInformation">
  <mat-icon class="itemInformation__icon">{{ icon }}</mat-icon>
  <article *ngIf="!haveLabel" class="itemInformation__field field">
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </article>

  <article *ngIf="haveLabel" class="itemInformation__field field">
    <label class="field__label">{{ label || 'N/A' }}</label>
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </article>
</article>
<ng-template #text>
  <span
    [matTooltip]="info"
    class="field__text text"
    [ngClass]="{
      'text--isImportant': isImportant,
      'text--isTruncate': isTruncateField
    }"
    *ngIf="type === 'text' && !haveTitleCase"
    >{{ info || 'N/A' }}</span
  >
  <span
    [matTooltip]="info"
    class="field__text text"
    [ngClass]="{
      'text--isImportant': isImportant,
      'text--isTruncate': isTruncateField
    }"
    *ngIf="type === 'text' && haveTitleCase"
    >{{ info || 'N/A' }}</span
  >
  <span
    class="field__text text"
    [ngClass]="{ 'text--isImportant': isImportant }"
    *ngIf="type === 'birthDate'"
    >{{ info | yearsOld }}</span
  >
  <span
    class="field__text text"
    [ngClass]="{ 'text--isImportant': isImportant }"
    *ngIf="type === 'date'"
    >{{ (info | date: 'MM/d/y') || 'N/A' }}</span
  >
</ng-template>
